// import React from 'react'
import { useState, useRef } from "react";
import LimitedColorPicker from "../LimitedColorPicker";
import { useNavigate } from "react-router-dom";

function LuxuryRingBox({ stateChanger, save, state, otherColors }) {
  const boxColor = [
    { title: "White", color: "#fff" },
    { title: "Black", color: "#0c0c0c" },
    { title: "Dark Grey", color: "#555555" },
    { title: "Light Grey", color: "#D3D3D3" },
    { title: "Ivory", color: "#f0ecd3" },
    { title: "Cream", color: "#FFFDD0" },
    { title: "Grey", color: "#363739" },
    { title: "Navy", color: "#000060" },
    // { title: "Teal", color: "#304a46" },
    { title: "Teal", color: "#30504d" },
    { title: "Linen", color: "#c3bdb1" },
    { title: "Sand", color: "#C0AA79" },
    { title: "Copper", color: "#b97c5f" },
    { title: "Steel Blue", color: "#2f3d62" },
    { title: "Slate Grey", color: "#9e988c" },
    { title: "Pewter", color: "#af7148" },
    { title: "Sage", color: "#629278" },
    { title: "Beige", color: "#aba58b" },
    { title: "Rose", color: "#ce9ca7" },
    { title: "Maroon", color: "#7f1722" },
    { title: "Taupe", color: "#849e9b" },
    { title: "Olive", color: "#97916f" },
    { title: "Burgundy", color: "#9e5e6e" },
    { title: "Brick", color: "#8f2434" },
    { title: "Army", color: "#4f5241" },
    { title: "Khaki", color: "#7f755a" },
    { title: "Stone", color: "#9a9c8f" },
    { title: "Plum", color: "#633a58" },
    { title: "Evergreen", color: "#2d4340" },
    { title: "Hazel", color: "#837457" },
    { title: "Chocolate", color: "#5b4f3f" },
    { title: "Dark Brown", color: "#352629" },
    { title: "Midnight", color: "#20242d" },
    { title: "Drab", color: "#6f582c" },
    { title: "Azure", color: "#1e6da6" },
    { title: "Charcoal", color: "#363739" },
    { title: "Jet Black", color: "#202020" },
  ];

  const innerColor = [
    { title: "White", color: "#ECECEC", color2: "#fff" },
    { title: "Black", color: "#0c0c0c" },
    { title: "Dark Grey", color: "#555555" },
    { title: "Light Grey", color: "#D3D3D3" },
    { title: "Ivory", color: "#f0ecd3" },
    { title: "Cream", color: "#FFFDD0" },
    // { title: "Linen", color: "#c3bdb1" },
    // { title: "Sand", color: "#C0AA79" },
    // { title: "Copper", color: "#b97c5f" },
    // { title: "Steel Blue", color: "#2f3d62" },
    // { title: "Slate Grey", color: "#9e988c" },
    // { title: "Pewter", color: "#af7148" },
    // { title: "Sage", color: "#629278" },
    // { title: "Beige", color: "#aba58b" },
    // { title: "Rose", color: "#ce9ca7" },
    // { title: "Maroon", color: "#7f1722" },
    // { title: "Taupe", color: "#849e9b" },
    // { title: "Olive", color: "#97916f" },
    // { title: "Burgundy", color: "#9e5e6e" },
    // { title: "Brick", color: "#8f2434" },
    // { title: "Army", color: "#4f5241" },
    // { title: "Khaki", color: "#7f755a" },
    // { title: "Stone", color: "#9a9c8f" },
    // { title: "Plum", color: "#633a58" },
    // { title: "Evergreen", color: "#2d4340" },
    // { title: "Hazel", color: "#837457" },
    // { title: "Chocolate", color: "#5b4f3f" },
    // { title: "Dark Brown", color: "#352629" },
    // { title: "Midnight", color: "#20242d" },
    // { title: "Drab", color: "#6f582c" },
    // { title: "Azure", color: "#1e6da6" },
    // { title: "Charcoal", color: "#363739" },
    // { title: "Jet Black", color: "#202020" },
  ];
  const [colorsChange, setColorChange] = useState();
  const navigate = useNavigate();

  const handleColorChange = () => {
    setColorChange((prevIndex) => (prevIndex + 1) % boxColor.length);
  };
  const currentColors = boxColor[colorsChange];
  return (
    <>
      <div className=" flex flex-col items-start gap-5 mt-[20px]">
        <h2 className="text-[24px]" style={{ fontFamily: "ZapfHumanistBold" }}>
          LUXURY RING BOX
        </h2>
        <p className="text-[14px]">
          We have many styles of jewellery box and sets available, for rings,
          necklace, pendants and more. To help you get started designing your
          own collection, we've showcased our popular ring box in faux
          leatherette. We have select range of paper textures for you to choose
          for this box type. As for your branding, we offer debossing, embossing
          and hot foil stamping in both matt and metallic finishes.
          <p style={{ fontFamily: "ZapfHumanistBold" }}>
            After something bespoke?
          </p>
          <p style={{ fontFamily: "ZapfHumanistBold" }}>
            We can help you with this upon completion of the customiser steps.
          </p>
        </p>
        <div className="flex flex-col gap-2">
          <p
            className="text-[16px] mb-2"
            style={{ fontFamily: "ZapfHumanistBold" }}
          >
            EXTERIOR
          </p>
          <LimitedColorPicker
            render={boxColor}
            stateChanger={stateChanger}
            keyVal={"boxColor"}
          />
          <p
            className="text-[16px] mb-2 mt-1"
            style={{ fontFamily: "ZapfHumanistBold" }}
          >
            INTERIOR
          </p>
          <LimitedColorPicker
            render={innerColor}
            stateChanger={stateChanger}
            keyVal={"innerColor"}
          />
        </div>
        <div className="flex mt-[-18px]">
          <div className="flex gap-2">
            <button
              style={{ fontFamily: "ZapfHumanistBold" }}
              className="bg-red-500 hover:bg-[#02595A] text-white px-3 py-2 mt-8 rounded-full text-[18px] w-[165px] focus:border border-[#0F0F0F] border-solid transition-transform duration-300 hover:scale-110"
              onClick={save}
            >
              SAVE PROGRESS
            </button>
            <button
              style={{ fontFamily: "ZapfHumanistBold" }}
              className="bg-red-500 hover:bg-[#02595A] text-white px-3 py-2 mt-8 rounded-full text-[18px] w-[165px] focus:border border-[#0F0F0F] border-solid transition-transform duration-300 hover:scale-110"
              onClick={() => {
                navigate("/form", { state });
              }}
            >
              SKIP TO END
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default LuxuryRingBox;
